import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Hersteller')
    .setRoute('manufacturer_list')
    .setAdditionalRoutes([
        'manufacturer_edit',
        'manufacturer_create',
    ]);
